module.exports = __webpack_public_path__ + "static/media/agent5.3a71fdf5.png";